import getTemplate from './get/template.html';
import getCtrl from './get/controller';

const authorActivitiesState = {
  url: '/activities',
  stateName: 'Activity Manager',
  data: {
    specialClass: 'fixed-sidebar'
  },
  resolve: {
    ResolveClass: 'ResolveClass',
    authenticateCompany: /* @ngInject */ ResolveClass => ResolveClass.authenticateCompany('/author/:id/activities')
  },
  views: {
    'a@app': {
      template: getTemplate,
      controller: getCtrl,
      controllerAs: 'authorActivitiesCtrl'
    }
  }
};

import editTemplate from './edit/template.html';
import editCtrl from './edit/controller';

const authorActivitiesActivityState = {
  url: '/:activity_id?tour&tab',
  stateName: 'Activity',
  data: {
    specialClass: 'fixed-sidebar'
  },
  resolve: {
    ResolveClass: 'ResolveClass',
    authenticateCompany: /* @ngInject */ ResolveClass =>
      ResolveClass.authenticateCompany('/author/:id/activities/:activityId')
  },
  views: {
    'a@app': {
      template: editTemplate,
      controller: editCtrl,
      controllerAs: 'authorActivityCtrl'
    }
  }
};

import viewTemplate from './view/template.html';
import viewCtrl from './view/controller';

const authorActivitiesActivityViewState = {
  url: '/view',
  stateName: 'Activity Preview',
  data: {
    specialClass: 'fixed-sidebar'
  },
  views: {
    'a@app': {
      template: viewTemplate,
      controller: viewCtrl,
      controllerAs: 'authorActivityViewCtrl'
    }
  }
};

export { authorActivitiesState, authorActivitiesActivityViewState, authorActivitiesActivityState };



// WEBPACK FOOTER //
// ./src/app/controllers/author/activities/index.js